import { action } from '@sas/nova-commons/action';
import { createReducer } from '../utils/action/createReducer';
const AT = {
    OpenReportContextMenu: 'reportContextMenu/open',
    CloseReportContextMenu: 'reportContextMenu/close',
    SetReportItemSortKeys: 'reportContextmenu/setReportItemSortKeys',
    SetReportItems: 'reportContextMenu/setReportItems',
    SetReportItem: 'reportContextMenu/setReportItem',
    SetObjectItemSortKeys: 'reportContextmenu/setObjectItemSortKeys',
    SetObjectItems: 'reportContextMenu/setObjectItems',
    SetObjectItem: 'reportContextMenu/setObjectItem',
    SetReportContextMenuTarget: 'reportContextMenu/setReportContextMenuTarget',
    SetGraphPosition: 'reportContextMenu/setGraphPosition',
};
const initialState = {
    position: { x: 0, y: 0 },
    graphPosition: null,
    open: false,
    target: null,
    timestamp: null,
    reportItems: {},
    reportItemSortKeys: [],
    objectItems: {},
    objectItemSortKeys: [],
};
export const ReportContextMenuState = {
    elementName: 'reportContextMenu',
    actions: {
        open: (position) => action(AT.OpenReportContextMenu, position),
        close: () => action(AT.CloseReportContextMenu),
        setGraphPosition: (position) => action(AT.SetGraphPosition, position),
        setReportContextMenuTarget: (id, timestamp) => action(AT.SetReportContextMenuTarget, { id, timestamp }),
        setReportItemSortKeys: (sortKeys) => action(AT.SetReportItemSortKeys, sortKeys),
        setReportItems: (items) => action(AT.SetReportItems, items),
        setReportItem: (key, item) => action(AT.SetReportItem, { key, item }),
        setObjectItemSortKeys: (sortKeys) => action(AT.SetObjectItemSortKeys, sortKeys),
        setObjectItems: (items) => action(AT.SetObjectItems, items),
        setObjectItem: (key, item) => action(AT.SetObjectItem, { key, item }),
    },
    actionTypes: AT,
    reducer: createReducer(initialState, {
        [AT.OpenReportContextMenu]: (state, action) => {
            return Object.assign(Object.assign({}, state), { open: true, position: action.payload });
        },
        [AT.SetReportContextMenuTarget]: (state, action) => {
            if (action.payload.timestamp === state.timestamp) {
                return state; // the target for this event was already set
            }
            return Object.assign(Object.assign({}, state), { target: { id: action.payload.id }, timestamp: action.payload.timestamp });
        },
        [AT.CloseReportContextMenu]: (state) => {
            return Object.assign(Object.assign({}, initialState), { reportItemSortKeys: state.reportItemSortKeys, objectItemSortKeys: state.objectItemSortKeys });
        },
        [AT.SetReportItemSortKeys]: (state, action) => {
            return Object.assign(Object.assign({}, state), { reportItemSortKeys: action.payload });
        },
        [AT.SetReportItems]: (state, action) => {
            return Object.assign(Object.assign({}, state), { reportItems: action.payload });
        },
        [AT.SetReportItem]: (state, action) => {
            return Object.assign(Object.assign({}, state), { reportItems: Object.assign(Object.assign({}, state.reportItems), { [action.payload.key]: action.payload.item }) });
        },
        [AT.SetObjectItemSortKeys]: (state, action) => {
            return Object.assign(Object.assign({}, state), { objectItemSortKeys: action.payload });
        },
        [AT.SetObjectItems]: (state, action) => {
            return Object.assign(Object.assign({}, state), { objectItems: action.payload });
        },
        [AT.SetObjectItem]: (state, action) => {
            return Object.assign(Object.assign({}, state), { objectItems: Object.assign(Object.assign({}, state.objectItems), { [action.payload.key]: action.payload.item }) });
        },
        [AT.SetGraphPosition]: (state, action) => {
            return Object.assign(Object.assign({}, state), { graphPosition: action.payload });
        },
    }),
};
